import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperNavigationComponent } from './stepper-navigation.component';
import { StepperNavigationService } from './stepper-navigation.service';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../../../framework/material/material.module';
import { FeatureAllowModule } from '../directives/features-allow.module';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [StepperNavigationComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    FeatureAllowModule,
    MaterialModule,
    TranslateModule,
    RouterModule
  ],
  providers: [StepperNavigationService],
  entryComponents: [StepperNavigationComponent],
  exports: [ StepperNavigationComponent ]
})
export class StepperNavigationModule { }
